<template>
  <div
    class="drawer__header get-height"
    :class="{ 'drawer__header--open': isOpen }"
  >
    <h2 v-if="isOpen" class="drawer__header__title text--nowrap">{{ $t(`${namespace}.callACar`) }}</h2>

    <v-btn class="drawer__header__btn" flat icon @click="handleToggleVisibility">
      <v-icon v-if="isOpen">keyboard_arrow_right</v-icon>
      <v-icon v-else>keyboard_arrow_left</v-icon>
    </v-btn>

    <v-menu v-if="isOpen && !noMainMenuFromV4" class="drawer__header__menu" max-width="200" min-width="200" offset-y left>
      <v-btn class="drawer__header__menu__btn" slot="activator" flat>
        <v-icon color="gray-6">account_circle</v-icon>
        <v-icon class="hidden-xs-only ml-1" right small>keyboard_arrow_down</v-icon>
      </v-btn>

      <v-list>
        <v-list-tile @click="logoutSession">
          <v-list-tile-title class="fs-14">
            {{ $t('Common.logout') }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Header',
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage'
    }
  },
  methods: {
    ...mapActions({
      logout: 'session/logout',
      clearUserClaims: 'userClaims/clear',
      clearSelectedCompany: 'company/clearSelectedCompany',
      clearCostCenterCounter: 'costCenter/clear',
      noMainMenuFromV4: ({ mainMenu }) => mainMenu.noMainMenuFromV4
    }),

    handleToggleVisibility () {
      this.$emit('toggleVisibility')
    },

    logoutSession () {
      this.logout()
      this.clearUserClaims()
      this.clearSelectedCompany()
      this.clearCostCenterCounter()

      if (window.Botkit) {
        window.removeEventListener('message', window.Botkit.receiveMessage, false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer__header {
  align-items: center;
  border-bottom: 1px solid $gray-4;
  display: flex;
  height: 64px;
  justify-content: center;
  min-height: 64px;
  padding: 0;
  position: relative;

  &.drawer__header--open {
    justify-content: space-between;
    padding: 8px 0 8px 16px;

    .drawer__header__btn {
      background-color: #fff;
      border-radius: 50% 0 0 50%;
      margin: 0;
      position: absolute;
      right: 100%;
      top: 50%;
      transform: translateY(-50%);

      &:before {
        border-radius: 50% 0 0 50%;
      }

      &:after {
        background-image: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.2));
        bottom: 0;
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 5px;
        z-index: 1;
      }
    }
  }
}

.drawer__header__title {
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 700;
}

.drawer__header__menu__btn {
  height: 64px;
  margin: 0;
  min-width: 60px;
}
</style>
